import React from 'react';
import PropTypes from 'prop-types';
import {formatMoney} from '@shopify/theme-currency';

import {imageUrl} from '../../../../assets/scripts/utils/shopify-images';
import iconMinus from '../../../../assets/svg/icon-minus.svg';
import iconPlus from '../../../../assets/svg/icon-plus.svg';
import iconDiscount from '../../../../assets/svg/icon-discount.svg';
import iconArrowReturnRight from '../../../../assets/svg/icon-arrow-return-right.svg';

const CartItem = ({item, customData, updateLineItems}) => {
  const truncate = (string) => (string.length > 50 ? `${string.substring(0, 47)}...` : string);

  return (
    <li className="cart-item">
      <div className="cart-item__content-wrapper">
        <div className="cart-item__content">
          <p className="cart-item__title">{item.product_title.split(' - ')[0]}</p>
          {item.variant_title && item.product_type !== 'Gift Cards' && (
            <p className="cart-item__variant">{item.variant_title}</p>
          )}
          {item.properties && item.properties?.preorder && (
            <p className="cart-item__preorder">{window.theme.strings.preorder}</p>
          )}
          {item.line_level_discount_allocations.length > 0 && (
            <div className="cart-item__discounts">
              {item.line_level_discount_allocations.map((discount) => (
                <p className="cart-item__discount-name" key={discount.discount_application.title}>
                  <span className="cart-item__discount-icon" dangerouslySetInnerHTML={{__html: iconDiscount}} />
                  {discount.discount_application.title}
                </p>
              ))}
            </div>
          )}
          {item.line_level_total_discount === 0 ? (
            <div className="cart-item__price-container">
              <div class="cart-item__compare">
                <span className="cart-item__price">{formatMoney(item.final_line_price, window.theme.moneyFormat)}</span>
                {item.properties && item.properties?._compare_at_price > item.original_price ? (
                  <s className="cart-item__compare-price">
                    {formatMoney(item.properties._compare_at_price * item.quantity, window.theme.moneyFormat)}
                  </s>
                ) : null}
              </div>
            </div>
          ) : (
            <div className="cart-item__price-container cart-item__price-container--discounted">
              <span className="cart-item__price cart-item__price-original">
                {formatMoney(item.original_line_price, window.theme.moneyFormat)}
              </span>
              <span className="cart-item__price">{formatMoney(item.final_line_price, window.theme.moneyFormat)}</span>
            </div>
          )}
          {item.properties?.__shopify_send_gift_card_to_recipient &&
            (item?.properties['Recipient name'] || item?.properties.Message) && (
              <div className="cart-item__gift-card-message">
                <span className="cart-item__gift-card-arrow" dangerouslySetInnerHTML={{__html: iconArrowReturnRight}} />
                {item?.properties['Recipient name'] && item.properties['Recipient name']}
                {item?.properties.Message && `: ${truncate(item.properties.Message)}`}
              </div>
            )}
          <div className="cart-item__info-container">
            {item.line_price > 0 && (
              <div className="cart-item__quantity-selector">
                <button
                  onClick={() => updateLineItems({[item.key]: item.quantity - 1})}
                  className="btn-none"
                  type="button"
                >
                  <span dangerouslySetInnerHTML={{__html: iconMinus}} />
                </button>
                <input
                  id={`cart-qty_${item.key}`}
                  type="number"
                  name="quantity"
                  min="1"
                  aria-label={window.theme.strings.itemQuantity}
                  value={item.quantity}
                  autoComplete="off"
                  onBlur={(event) =>
                    item.quantity === Number(event.target.value)
                      ? null
                      : updateLineItems({[item.key]: event.target.value})
                  }
                />
                <button
                  onClick={() => updateLineItems({[item.key]: item.quantity + 1})}
                  className="btn-none"
                  type="button"
                >
                  <span dangerouslySetInnerHTML={{__html: iconPlus}} />
                </button>
              </div>
            )}
            {customData && customData.inventoryWarning !== '' && (
              <div class="cart-item__inventory-warning">{customData.inventoryWarning}</div>
            )}
          </div>
        </div>
      </div>
      {item?.featured_image?.url && (
        <div className="cart-item__image">
          <a className="aspect-ratio aspect-ratio--portrait" href={item.url}>
            <img
              src={imageUrl(item.featured_image.url, 180, 240, 'center')}
              width={90}
              height={120}
              alt={item.title}
              loading="lazy"
            />
          </a>
        </div>
      )}
    </li>
  );
};

CartItem.propTypes = {
  item: PropTypes.object,
  customData: PropTypes.object,
  updateLineItems: PropTypes.func,
};

export default CartItem;
